import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthorizationService, OrganizationService, SupersetService, TitleService } from '@ng-cloud/badger-core';
import { embedDashboard } from '@superset-ui/embedded-sdk';

@Component({
  selector: 'badger-portal-store-dashboard',
  templateUrl: './organization-dna.component.html',
  styleUrl: './organization-dna.component.scss',
  standalone: false
})
export class OrganizationDnaComponent implements OnInit, AfterViewInit {
  storeMaps = [];

  organizationName: string;
  protected loading = true;

  constructor(
    private authorizationService: AuthorizationService,
    private organizationService: OrganizationService,
    private titleService: TitleService,
    private supersetService: SupersetService
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('Badger D&A');

    const orgId = this.authorizationService.getCurrentUserOrgId();

    if (orgId) {
      this.organizationService.getOrganization(orgId).subscribe(organization => {
        this.organizationName = organization.name;
      });
    }
  }

  ngAfterViewInit(): void {
    this.supersetService.getEmbedInfo('OrganizationOverview', 'Portal').subscribe(info => {
      embedDashboard({
        id: info.guid,
        supersetDomain: this.supersetService.getSupersetDomain(),
        mountPoint: document.getElementById('dashboard'),
        debug: true,
        fetchGuestToken: () => info.guest_token,
        dashboardUiConfig: { // TODO: dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional), urlParams (optional)
          hideTitle: false,
          hideTab: false,
          hideChartControls: false,
          filters: {
            expanded: true
          }
        },
        iframeSandboxExtras: ['allow-same-origin', 'allow-scripts', 'allow-popups-to-escape-sandbox', 'allow-top-navigation', 'allow-modals', 'allow-downloads', 'allow-popups']
      }).then(() => {
        const dashboardIFrame = document.getElementById('dashboard').children[0] as HTMLElement;

        if (dashboardIFrame) {
          dashboardIFrame.style.width = '100%';
          dashboardIFrame.style.height = '100%';
          setTimeout(() => this.loading = false, 500);
        }
      }).catch((error) => {
        console.error('Error embedding dashboard:', error);
        this.loading = false;
      });
    });
  }
}
